<!--
 * @Date: 2022-12-09 15:00:26
 * @LastEditTime: 2022-12-19 19:29:46
 * @Description: file content
-->
<!--
 * @Date: 2022-12-08 17:58:35
 * @LastEditTime: 2022-12-09 14:42:28
 * @Description: file content
-->
<!--
 * @Date: 2022-12-08 14:18:53
 * @LastEditTime: 2022-12-08 17:54:41
 * @Description: file content
-->
<template>
  <div id="preload-page">
    <div id="opening" class="fadein">
      <div id="video-holder">
        <!-- <img
          id="background"
          src="https://resource.chunyu.mobi/@/media/images/2022/12/12/12fe/a0848d31a432_w2250_h4874_.png"
        /> -->
        <div id="background" />
        <div id="halo" :class="{ 'animated-halo': isStarted }" />
        <img
          src="https://resource.chunyu.mobi/@/media/images/2022/12/19/0514/5371f0931e23_w1637_h2298_.png"
          alt=""
          class="month month-1"
        /><img
          src="https://resource.chunyu.mobi/@/media/images/2022/12/19/1056/04e3eb368e90_w1637_h2301_.png"
          alt=""
          class="month month-2"
        />
        <img
          class="month month-3"
          src="https://resource.chunyu.mobi/@/media/images/2022/12/19/957a/805d6303ad66_w899_h68_.png"
          alt=""
        />
        <!--  -->
        />
      </div>
    </div>
    <SlideUp :show-arrow="false" class="slide-up" />
  </div>
</template>

<script>
import PageMixin from '@/mixins/mixin.js';
import SlideUp from './slideUp.vue';

export default {
  name: 'PreloadPage',
  components: { SlideUp },
  mixins: [PageMixin],
  data() {
    return {
      isStarted: false,
      percentage: 0,
      isLoadingShow: true,
    };
  },
  computed: {
    hasData() {
      return true;
      // return Object.keys(this.detail).length > 0;
    },
  },
  mounted() {
    setTimeout(() => {
      this.isStarted = false;
    }, 1000);
  },
  methods: {
    startVideo() {
      this.isStarted = true;
      setTimeout(() => {
        this.$emit('animate-end');
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.fadein {
  opacity: 0.3;
  animation-name: fadein;
  animation-duration: 1s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}
@function rem($px) {
  @return $px / 41.4 * 1rem;
}
$durationTime: 2.5s;

#preload-page {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  #preload {
    #assets {
      position: absolute;
      width: 0;
      height: 0;
      overflow: hidden;
    }
  }

  #no-data-page {
    position: absolute;
    z-index: 5;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);

    #text-holder {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      transform: translate(-50%, -50%);
      p {
        margin: 0;
        color: white;
        font-weight: bold;
        font-size: rem(22);
        line-height: rem(33);
        text-align: center;
      }
    }
  }

  #opening {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 100vh;
    transform: scale(1);
    &.zoomin {
      transform: scale(4);
      animation-name: zoomin;
      animation-duration: $durationTime;
      animation-timing-function: ease-in-out;
      @keyframes zoomin {
        0% {
          transform: scale(1);
        }
        100% {
          transform: scale(4);
        }
      }
    }
    #video-holder {
      position: relative;

      #preload-video {
        z-index: 3;
        width: 100%;
        pointer-events: none;
      }
      #background {
        position: relative;
        z-index: 5;
        width: 100%;
        height: 100vh;
        background: url('https://resource.chunyu.mobi/@/media/images/2022/12/12/12fe/a0848d31a432_w2250_h4874_.png')
          no-repeat;
        background-position: 100% 100%;
        background-size: 100%;
      }
      #halo {
        position: absolute;
        top: 18%;
        left: 50%;
        z-index: 7;
        width: rem(300);
        height: rem(300);
        margin-top: 52%;
        background: radial-gradient(#fff, rgba(255, 255, 255, 0) 70%);
        border-radius: 50%;
        transform: translate(-50%, -50%);
        opacity: 0;
        &.animated-halo {
          z-index: 9;
          opacity: 1;
          animation-name: halo;
          animation-duration: 1s;
          animation-timing-function: linear;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
          @keyframes halo {
            0% {
              opacity: 0;
            }
            100% {
              width: 150vh;
              height: 150vh;
              background: radial-gradient(#fff, rgba(255, 255, 255, 0) 70%);
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .header {
    position: absolute;
    top: 8%;
    left: 50%;
    z-index: 6;
    width: rem(299);
    transform: translateX(-50%);
  }
  .month {
    position: absolute;
    top: 10.5%;
    left: 50%;
    z-index: 6;
    width: rem(294);
    transform: translateX(-50%) translateY(-10%);
    opacity: 0;
    animation-name: movein;
    animation-duration: 1s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    @keyframes movein {
      100% {
        transform: translateX(-50%) translateY(0%);
        opacity: 1;
      }
    }
    @keyframes movein2 {
      100% {
        transform: translateY(0%);
        opacity: 1;
      }
    }
    &.month-2 {
      top: 10.4%;
      transform: translate(-50%, 0);
      opacity: 0;
      animation-name: fadein;
      animation-delay: 1s;
    }
    &.month-3 {
      top: 80%;
      right: 3%;
      left: auto;
      width: rem(165);
      transform: translate(-0, -10%);
      animation-name: movein2;
    }
  }
  .slide-up {
    position: absolute;
    bottom: 6%;
    left: 50%;
    z-index: 2;
    transform: translateX(-50%);
  }

  @keyframes fadein {
    100% {
      opacity: 1;
    }
  }
}
</style>
